module.exports = __webpack_public_path__ + "img/img_6.43fe1b1d.svg";